module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--1--redeem-36084b68.png";